import { BellIcon } from 'assets/svg';
import React from 'react';

const Bell = () => {
  return <BellIcon className="cursor-pointer w-[20px] h-[20px]" />;
};

export default Bell;
